module.exports = __webpack_public_path__ + "static/img/yeswecan0037.6edbeea.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0037.png
// module id = 603
// module chunks = 1